export class PagesRouting {
  public static MainPages = {
    DashboardPage: {
      Dashboard: '/dashboard',
    },
    SalesPage: {
      Sales: '/sales',
      SalesSettings: '/sales/settings',
    },
    PurchasesPage: '/purchases',
    LogisticsPage: {
      Logistics: '/logistics',
      LogisticsSettings: '/logistics/settings',
    },
    ProductsPage: {
      Products: '/products',
      ProductsSettings: '/products/settings',
    },
    WarehousePage: {
      Warehouse: '/warehouse',
      WarehouseSettings: '/warehouse/settings',
      UnitsTab: '/warehouse/units',
      TransferTab: '/warehouse/transfer',
      ReportsTab: '/warehouse/reports',
    },
    MessagesPage: '/messages',
    SuppliersPage: {
      Suppliers: '/suppliers',
      SuppliersSettings: '/suppliers/settings',
    },
    CustomersPage: {
      Customers: '/customers',
      CustomersSettings: '/customers/settings',
    },
    ListingPage: '/listing',
    DesignServicePage: '/design-service',
    OnlineArchivePage: {
      OnlineArchive: '/accounting',
      OnlineArchiveSettings: '/accounting/settings',
      UploadTab: '/accounting/upload',
      AllocateTab: '/accounting/allocate',
      ArchiveTab: '/accounting/archive',
      ReportsTab: '/accounting/reports',
    },
    ShopPage: {
      Shop: '/shop',
      ShopSettings: '/shop/settings',
    },
    PermissionDenied: '/permission-denied',
    PaymentsPage: {
      Payments: '/payments',
      SuccessPayment: '/payments/success',
      ErrorPayment: '/payments/error',
    },
  };

  public static AuthorizationPages = {
    LoginPage: '/login',
    RegistrationPage: '/registration',
    EmailConfirmationPage: '/email-confirmation',
    ResetPasswordPage: '/reset-password',
    ChangePasswordPage: '/change-password',
  };

  public static SettingsPages = {
    Settings: '/settings',
    AccountSettings: '/settings/account',
    SynchronizeSettings: '/settings/synchronize',
    MandatsSettings: '/settings/mandats',
    OrderAutomationSettings: '/settings/order-automation',
    LogisticSettings: '/settings/logistic',
    ShippingAutomationSettings: {
      ShippingAutomation: '/settings/shipping-automation',
      AmountAutomation: '/settings/shipping-automation/amount',
      CategoryAutomation: '/settings/shipping-automation/category',
      PackagingAutomation: '/settings/shipping-automation/packaging',
      MixCategoryAutomation: '/settings/shipping-automation/mix-category',
    },
    AddressBookSettings: '/settings/address-book',
    PackagesSettings: '/settings/packages',
    MarketplacesSettings: '/settings/marketplaces',
    OnlineArchiveSetting: {
      OnlineArchive: '/settings/accounting',
      General: '/settings/accounting/general',
      DocumentCategories: '/settings/accounting/document-categories',
      AllocateCategories: '/settings/accounting/allocate-categories',
      UploadTemplates: '/settings/accounting/upload-templates',
      AccountChart: '/settings/accounting/account-chart',
      ScanDocuments: '/settings/accounting/scan-documents',
    },
    ProductsSettings: {
      Categories: '/settings/products',
    },
    InvoicesSettings: '/settings/invoices',
    FeedbacksSettings: '/settings/feedbacks',
    GridsColorsSettings: '/settings/grids-colors',
    IntegrationsSettings: '/settings/integrations',
    ShipCheaperApiSettings: '/settings/api',
    HelpSettings: '/settings/help',
    InfoSettings: '/settings/info',
    DocumentTemplateSettings: '/settings/document-templates',
    EmailTemplateSettings: '/settings/email-templates',
    WarehouseSettings: '/settings/warehouse',
  };

  public static AdminPages = {
    Admin: '/admin',
    AdminProductsPage: '/admin/products',
    AdminWarehousePage: '/admin/warehouse',
    AdminCustomersPage: '/admin/customers',
    AdminWarehouseLogisticsPage: {
      WarehouseLogistics: '/admin/warehouse-logistics',
      ProductSettings: '/admin/warehouse-logistics/product-settings',
      ProductGenerator: '/admin/warehouse-logistics/product-generator',
      CountryZones: '/admin/warehouse-logistics/country-zones',
      ApplicationAccess: '/admin/warehouse-logistics/application-access',
      LogisticLogoSettings: '/admin/warehouse-logistics/logo-settings',
    },
    AdminLanguageEditorPage: {
      LanguageEditor: '/admin/language-editor',
      ErpTranslations: '/admin/language-editor/erp-translations',
      WebsiteTranslations: '/admin/language-editor/website-translations',
      ProductTranslations: '/admin/language-editor/product-translations',
      EditorSettings: '/admin/language-editor/editor-settings',
    },
    AdminAccounting: {
      Accounting: '/admin/accounting',
      VatRates: '/admin/accounting/vat-rates',
    },
    AdminPermissionDenied: '/admin/permission-denied',
    AdminDigitalProductsPage: {
      DigitalProducts: '/admin/digital-products',
      ProductPrices: '/admin/digital-products/prices',
      TemplateSettings: '/admin/digital-products/templates',
    },
    AdminSubscriptionsPage: '/admin/subscriptions',
    AdminCalendarPage: {
      Calendar: '/admin/calendar',
      Holidays: '/admin/calendar/holidays',
    },
    AdminBillingPage: '/admin/billing',
  };

  public static ProfilePages = {
    BillingPage: '/profile/billing',
    PaymentsPage: '/profile/payments',
    SubscriptionsPage: '/profile/subscriptions',
  };
}
